import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col, Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, buttonField, controlledField} from '../../core/redux/form'
import {linkFinder} from '../../core/links'
import extract, {replace} from '../../core/extract'
import phonez, {phoneField} from '../../core/phonez'
import ButtonToggle from '../../core/components/ButtonToggle'
import Icon from '../../core/components/Icon'
import LoaderButton from '../../core/components/LoaderButton'
import {RECEIVE_CALL_CMD_UPDATED, updateReceiveCallCmd, sendReceiveCallCmd, sendAcceptInterventionCmd, sendRefuseInterventionCmd, loadTicket} from '../actions'
import {RECEIVE_CALL_FROM_ASSIGNEE_HINTS, RECEIVE_CALL_FROM_CALLER_HINTS, createValidator, mediumToContactMedium, plainContactToContactMedium, nameToPlainName, ReceiveCallCmd} from '../models'
import i18n from '../i18n'
import style from './ReceiveCallModal.less'

function assigneeHintFilter(_links) {
    return (hint) => {
        switch (hint) {
            case 'assigneeInterventionAcceptation': return !_links || !!_links.find(linkFinder('AcceptIntervention'))
            case 'assigneeInterventionCancellation': return !_links || !!_links.find(linkFinder('RefuseIntervention'))
            default: return true
        }
    }
}

function restrictMediums(assignee, caller, contactToCallback, callType) {
    switch(callType) {
        case 'ReceiveCallFromAssignee':
            const mediums = []
            mediums.push(...assignee.phones.map(plainContactToContactMedium('Phone')))
            mediums.push(...assignee.emails.map(plainContactToContactMedium('Mail')))
            mediums.push(...assignee.fax.map(plainContactToContactMedium('Fax')))
            return mediums
        case 'ReceiveCallFromCaller':
            return caller.medium.map(mediumToContactMedium)
        case 'ReceiveCallFromContactToCallback':
            return [mediumToContactMedium(contactToCallback.medium)]
        default:
            return []
    }
}

function restrictCallerz(assignee, caller, contactToCallback, callType) {
    switch(callType) {
        case 'ReceiveCallFromAssignee': return assignee.name
        case 'ReceiveCallFromCaller': return nameToPlainName(caller.name)
        case 'ReceiveCallFromContactToCallback': return contactToCallback.name
        default: return undefined
    }
}

function restrictCallTypes(assignee, caller, contactToCallback) {
    var callTypes = []
    
    if (assignee === undefined || caller === undefined) {
        callTypes.push('ReceiveCall')
    }
    if (assignee && caller) {
        callTypes.push('ReceiveCall')
    }
    if (assignee) {
        callTypes.push('ReceiveCallFromAssignee')
    }
    if (caller) {
        callTypes.push('ReceiveCallFromCaller')
    }
    if (contactToCallback) {
        callTypes.push('ReceiveCallFromContactToCallback')
    }

    return callTypes
}

function restrictHints(ticket, callType) {
    switch(callType) {
        case 'ReceiveCallFromAssignee': return RECEIVE_CALL_FROM_ASSIGNEE_HINTS.filter(assigneeHintFilter(ticket._links))
        case 'ReceiveCallFromCaller': return RECEIVE_CALL_FROM_CALLER_HINTS
        case 'ReceiveCallFromContactToCallback': return RECEIVE_CALL_FROM_CALLER_HINTS
        default: return []
    }
}

function computeInterventionCmdType(hint) {
    switch(hint) {
        case 'assigneeInterventionAcceptation': return 'AcceptIntervention'
        case 'assigneeInterventionCancellation': return 'RefuseIntervention'
        default: return null
    }
}

class ReceiveCallModal extends Component {
    static propTypes = {
        assignee: PropTypes.object,
        caller: PropTypes.object,
        contactToCallback: PropTypes.object,
        ticket: PropTypes.object.isRequired,
        onHide: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            hints: []
        }
    }

    componentWillMount() {
        const {dispatch, ticket, assignee, caller, contactToCallback} = this.props

        const callTypes = restrictCallTypes(assignee, caller, contactToCallback)
        const callType = callTypes[0]
        const hints = restrictHints(ticket, callType)

        const callerz = restrictCallerz(assignee, caller, contactToCallback, callType)
        const mediums = restrictMediums(assignee, caller, contactToCallback, callType)
        const medium = undefined
        const comment = undefined
        const callPurpose = undefined

        dispatch(updateReceiveCallCmd({callerz, medium, comment, callPurpose}))
        this.setState({callTypes, callType, mediums, hints})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticket !== this.props.ticket
            || nextProps.assignee !== this.props.assignee
            || nextProps.caller !== this.props.caller
            || nextProps.contactToCallback !== this.props.contactToCallback) {
            const {dispatch, ticket,  assignee, caller, contactToCallback} = nextProps

            const callTypes = restrictCallTypes(assignee, caller, contactToCallback)
            const callType = callTypes[0]
            const hints = restrictHints(ticket, callType)

            const callerz = restrictCallerz(assignee, caller, contactToCallback, callType)
            const mediums = restrictMediums(assignee, caller, contactToCallback, callType)
            const medium = undefined
            const comment = undefined
            const callPurpose = undefined
            const hint = undefined
            const interventionCmdType = undefined
            
            dispatch(updateReceiveCallCmd({callerz, medium, comment, callPurpose}))
            this.setState({callTypes, callType, mediums, hints, hint, interventionCmdType})
        }
    }

    _sendCmd() {
        const {dispatch, ticket, onHide} = this.props
        const {interventionCmdType} = this.state
        
        return dispatch(sendReceiveCallCmd(ticket.uid)).then(() => {
            switch(interventionCmdType) {
                case 'AcceptIntervention': return dispatch(sendAcceptInterventionCmd(ticket.uid))
                case 'RefuseIntervention': return dispatch(sendRefuseInterventionCmd(ticket.uid))
            }
        }).then(() => {
            return dispatch(loadTicket())
        }).then(() => {
        }).then(() => {
            dispatch(push('/tickets/' + ticket.uid))
            onHide()
        })
    }

    _toggleCallType(callType) {
        const {dispatch, ticket, assignee, caller, contactToCallback} = this.props

        if (callType) {
            const callerz = restrictCallerz(assignee, caller, contactToCallback, callType)
            const mediums = restrictMediums(assignee, caller, contactToCallback, callType)
            const hints = restrictHints(ticket, callType)
            const medium = undefined
            const comment = undefined
            const callPurpose = undefined
            const hint = undefined

            dispatch(updateReceiveCallCmd({callerz, medium, comment, callPurpose}))
            this.setState({callType, mediums, hints, hint})
        }
    }

    render() {
        const {dispatch, form, cmd, assignee, caller, contactToCallback, ticket, onHide, ...others} = this.props
        const {callTypes, callType, mediums, hints, hint} = this.state

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        const inputAddon = (icon) => (
            <Icon icon={icon} size='xs' />
        )

        const mediumInputButton = (medium) => (
            <Button
                {...buttonField(form.medium(), medium)}>
                <Icon icon='radio' size='xs' />
            </Button>
        )

        const mediumField = (field, type) => {
            const disabled = field.value && field.value.contactMediumType != type || false
            var value

            switch(type) {
                case 'Phone':
                    value = field.value && field.value.phone
                    break
                case 'Mail':
                    value = field.value && field.value.mail
                    break
                case 'Fax':
                    value = field.value && field.value.fax
                    break
            }

            function onChange(eventOrValue) {
                var value
                if (eventOrValue && eventOrValue.target) {
                    value = eventOrValue.target.value
                } else {
                    value = eventOrValue
                }
                
                var medium
                switch(type) {
                    case 'Phone':
                        medium = value && {phone: value, contactMediumType: 'Phone'} || null
                        break
                    case 'Mail':
                        medium = value && {mail: value, contactMediumType: 'Mail'} || null
                        break
                    case 'Fax':
                        medium = value && {fax: value, contactMediumType: 'Fax'} || null
                        break
                }

                field.onChange(medium)
            }

            return {...field, disabled, value, onChange}
        }

        const callTypeField = () => {
            const value = callType

            const onChange = (callType) => {
                this._toggleCallType(callType)
            }

            return {value, onChange}
        }

        const hintField = (field) => {
            const value = hint || ''

            const onChange = (event) => {
                const hint = event.target.value || null

                const data = {
                    name: cmd.callerz || i18n.namePlaceholder
                }

                const callPurpose = extract(i18n.receiveCallHintEnum, hint)
                const comment = replace(extract(i18n.receiveCallCommentEnum, hint), data)

                const interventionCmdType = computeInterventionCmdType(hint)

                dispatch(updateReceiveCallCmd({callPurpose, comment}))
                this.setState({hint, interventionCmdType})
            }

            return {...field, value, onChange}
        }

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{extract(i18n.receiveCallEnum, callType)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={style.defaultContent}>
                        {callTypes.length > 1 && (
                            <div className={style.callType}>
                                <Row>
                                    <Col sm={9} smOffset={3}>
                                        <ButtonToggle
                                            {...callTypeField()}>
                                            <ul className={style.container}>
                                                {callTypes.map((callType, index) => (
                                                    <li
                                                        key={index}>
                                                        <Button
                                                            bsStyle='link'
                                                            value={callType}>
                                                            <Icon
                                                                icon='clientAccountManager'
                                                                size='md' />
                                                            <span>{extract(i18n.receiveCallzEnum, callType)}</span>
                                                        </Button>
                                                    </li>
                                                ))}
                                            </ul>
                                        </ButtonToggle>
                                    </Col>
                                </Row>
                            </div>
                        )}
                        <form className='form-horizontal'>
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='text'
                                name='caller'
                                label={requiredLabel(i18n.caller)}
                                {...form.callerz()} />
                            {hints.length == 0 && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='textarea'
                                    name='callPurpose'
                                    label={requiredLabel(i18n.callPurposez)}
                                    {...form.callPurpose()} />
                            )}
                            {hints.length > 0 && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='select'
                                    name='callPurpose'
                                    label={requiredLabel(i18n.callPurposez)}
                                    {...hintField(form.callPurpose())}>
                                    <option value=''>{i18n.callPurposez} ...</option>
                                    {hints.map((hint) => (
                                        <option
                                            key={hint}
                                            value={hint}>
                                            {extract(i18n.receiveCallHintEnum, hint)}
                                        </option>
                                    ))}
                                </Input>
                            )}
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='textarea'
                                name='comment'
                                label={i18n.comment}
                                rows={4}
                                {...controlledField(form.comment())} />
                        </form>
                        <h5>
                            <span>{i18n.contactDetails} <i>*</i></span>
                            <small>{i18n.contactDetailsText}</small>
                        </h5>
                        <form className='form-horizontal'>
                            {mediums.length == 0 && (
                                <div>
                                    <Input
                                        labelClassName='col-sm-3'
                                        wrapperClassName='col-sm-9'
                                        type='text'
                                        name='phone'
                                        label={i18n.phone}
                                        addonBefore={inputAddon('phone')}
                                        {...phoneField(mediumField(form.medium(), 'Phone'))} />
                                    <Input
                                        labelClassName='col-sm-3'
                                        wrapperClassName='col-sm-9'
                                        type='text'
                                        name='email'
                                        label={i18n.email}
                                        addonBefore={inputAddon('mail')}
                                        {...mediumField(form.medium(), 'Mail')} />
                                    <Input
                                        labelClassName='col-sm-3'
                                        wrapperClassName='col-sm-9'
                                        type='text'
                                        name='fax'
                                        label={i18n.fax}
                                        addonBefore={inputAddon('fax')}
                                        {...phoneField(mediumField(form.medium(), 'Fax'))} />
                                </div>
                            )}
                            {mediums.filter((m) => m.contactMediumType == 'Phone').map((medium, index) => (
                                <Input disabled
                                    key={index}
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='phone'
                                    label={index == 0 && i18n.phone || ' '}
                                    addonBefore={inputAddon('phone')}
                                    buttonAfter={mediumInputButton(medium)}
                                    value={phonez(medium.phone).format()}
                                    bsStyle={form.medium().bsStyle} />
                            ))}
                            {mediums.filter((m) => m.contactMediumType == 'Mail').map((medium, index) => (
                                <Input disabled
                                    key={index}
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='email'
                                    label={index == 0 && i18n.email || ' '}
                                    addonBefore={inputAddon('mail')}
                                    buttonAfter={mediumInputButton(medium)}
                                    value={medium.mail}
                                    bsStyle={form.medium().bsStyle} />
                            ))}
                            {mediums.filter((m) => m.contactMediumType == 'Fax').map((medium, index) => (
                                <Input disabled
                                    key={index}
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='fax'
                                    label={index == 0 && i18n.fax || ' '}
                                    addonBefore={inputAddon('fax')}
                                    buttonAfter={mediumInputButton(medium)}
                                    value={phonez(medium.fax).format()}
                                    bsStyle={form.medium().bsStyle} />
                            ))}
                        </form>
                        <ButtonToolbar>
                            <LoaderButton
                                bsStyle='primary'
                                bsSize='large'
                                className={cx({disabled: !form.isValid()})}
                                onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                                {i18n.validate}
                            </LoaderButton>
                            <Button
                                bsSize='large'
                                onClick={onHide}>
                                {i18n.cancel}
                            </Button>
                        </ButtonToolbar>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

ReceiveCallModal = connectForm({
    validator: createValidator(),
    target: 'cmd',
    schema: ReceiveCallCmd.schema,
    action: RECEIVE_CALL_CMD_UPDATED
})(ReceiveCallModal)

ReceiveCallModal = connect((state) => ({
    cmd: state.ticket.receiveCallCmd
}))(ReceiveCallModal)

export default ReceiveCallModal


// WEBPACK FOOTER //
// ./lib/ticket/components/ReceiveCallModal.js